<div class="bot-order" *ngIf="!showCancel && !showBack">
  <div class="back-drop" [ngStyle]="{
      opacity: isCollapsed ? 1 : 0.3
    }">
    <div class="bot-order-head">
      <h4>{{botDetails.isBot?"Bot":'Position'}} Details</h4>
      <button class="bot-clear" (click)="goToPage()">
        <img src="assets/images/botclear.svg" alt="close" title="close" />
      </button>
    </div>

    <div class="tab-content" id="myTabContent" *ngIf="botDetails.isBot">
      <div class="tab-pane fade show active" id="strategies-tab-pane" role="tabpanel" aria-labelledby="strategies-tab"
        tabindex="0">
        <ul class="nav nav-tabs bottab mt-2 dcabot-details-tab-head" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="coin_one-details-tab" type="button" data-bs-toggle="tab"
              data-bs-target="#coin_one-details" role="tab" aria-controls="coin_one-details" aria-selected="true">
              Performance
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="coin_two-details-tab" type="button" data-bs-toggle="tab"
              data-bs-target="#coin_two-details" role="tab" aria-controls="coin_two-details" aria-selected="false">
              Settings
            </button>
          </li>
        </ul>
        <div class="tab-content dcabot-details-tab" id="myTabContent">
          <div class="tab-pane fade show active" id="coin_one-details" role="tabpanel"
            aria-labelledby="coin_one-details-tab">
            <h5 [ngClass]="{
                green_txt: botDetails.status == 'running',
                red_txt: botDetails.status != 'running'
              }">
              <img src="../../../../assets/images/checked.png" alt="Icon" class="img-fluid me-2" width="14px" />{{
              botDetails.status == "running" ? "Active" : "Inactive" }}
            </h5>
            <h5>
              <img src="../../../../assets/images/new-logo.svg" alt="Icon" class="img-fluid me-2" width="20px" /><span class="botType">BOT</span>
            </h5>
            <!-- <p class="greenTxt">USDT</p> -->
            <div class="detail-box-head">
              <!-- <div class="detail-box">
                <div class="d-flex gap-1 align-items-center">
                  <p>Bot profit (PNL with Fee)</p>
                  <img
                    src="../../../../assets/images/alert_img.png"
                    alt="Icon"
                    class="img-fluid"
                  />
                </div>
                <h5
                  [ngClass]="{
                    green_txt: botDetails.profitPerc > 0,
                    red_txt: botDetails.profitPerc < 0
                  }"
                >
                  {{ toFixedDown(botDetails.profitPerc, 2) }}%
                </h5>
                <h6
                  [ngClass]="{
                    green_txt: botDetails.profit > 0,
                    red_txt: botDetails.profit < 0
                  }"
                >
                  {{ toFixedDown(botDetails.profit, 2) }}
                </h6>
                <p class="mb-0">USDT</p>
              </div> -->

              <div class="detail-box d-flex gap-1 align-items-start justify-content-between mb-2">
                <div class="">
                  <p class="mb-0">Investment, USDT</p>
                  <p class="mb-0">{{ truncateDecimals(botDetails?.totalInvestment?? botDetails.investment,4) }}</p>
                </div>
                <!-- <div>
                  <p class="mb-0">Total PNL, USD1</p>
                  <div class="d-flex gap-1 align-items-center">
                    <p class="redText">-3.91%</p>
                    <p class="redText">0.38</p>
                  </div>
                </div> -->
              </div>
              <div class="d-flex gap-1 align-items-start justify-content-between">
                <div class="detail-box d-flex gap-1 align-items-start justify-content-between flex-grow-1">
                  <div class="">
                    <p class="mb-0">Bot profit</p>
                    <p [ngClass]="[
                        'mb-0',
                        botDetails.profit > 0 ? 'greenTxt' : 'redText'
                      ]">
                      {{ toFixedDown(botDetails.profit, 2) }} USDT
                    </p>
                  </div>
                </div>
                <div class="detail-box d-flex gap-1 align-items-start justify-content-between flex-grow-1">
                  <div class="">
                    <p class="mb-0">Bot profit %</p>
                    <p [ngClass]="[
                        'mb-0',
                        botDetails.profitPerc > 0 ? 'greenTxt' : 'redText'
                      ]">
                      {{ toFixedDown(botDetails.profitPerc, 2) }}%
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="bot_preview_box_wrapper">
              <!-- <div>
                <div class="bot_preview_box">
                  <div>
                    <span>Unrealized</span><span class="border_line"></span
                    ><span>USDT/-3.91</span>
                  </div>
                </div>
              </div> -->
              <!-- <div>
                <h3 class="bot_preview_title mt-2">In Orders</h3>
                <div class="bot_preview_box">
                  <div>
                    <span>Base currency</span><span class="border_line"></span
                    ><span>2.52000000 LDO</span>
                  </div>
                  <div>
                    <span>Quote currency</span><span class="border_line"></span
                    ><span>23.92846000 USDT</span>
                  </div>
                  <div>
                    <span>Value</span><span class="border_line"></span
                    ><span>9.9122 USDT</span>
                  </div>
                </div>
              </div>
              <div>
                <h3 class="bot_preview_title mt-2">Invested funds</h3>
                <div class="bot_preview_box">
                  <div>
                    <span>Base currency</span><span class="border_line"></span
                    ><span>O ETH</span>
                  </div>
                  <div>
                    <span>Quote currency</span><span class="border_line"></span
                    ><span>25 USDT</span>
                  </div>
                  <div>
                    <span>Value</span><span class="border_line"></span
                    ><span>25 USDT</span>
                  </div>
                </div>
              </div> -->
              <div>
                <h3 class="bot_preview_title mt-2">General info</h3>
                <div class="bot_preview_box">
                  <!-- <div>
                    <span>Transactions</span><span class="border_line"></span
                    ><span>1</span>
                  </div> -->
                  <div>
                    <span>Trading time</span><span class="border_line"></span><span>{{
                      dateHoursClose(
                      botDetails.createdAt,
                      botDetails.status != "running"
                      ? botDetails.stopedAt
                      : getNow()
                      )
                      }}</span>
                  </div>
                  <div>
                    <span>Bot ID</span><span class="border_line"></span><span (click)="
                          CopyText(botDetails._id)
                        ">
                      {{ maskId(botDetails._id) }}
                      <i class="bi bi-clipboard" style="color: #fcd535"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <button
              class="primary_btn w-100 mt-3"
              data-bs-toggle="modal"
              data-bs-target="#table_bot_modal"
              (click)="navigateToOrders()"
            >
              <span>Bot orders</span>
            </button> -->
          </div>

          <div class="tab-pane fade" id="coin_two-details" role="tabpanel" aria-labelledby="coin_two-details-tab">
            <div class="bot_preview_box_wrapper">
              <div>
                <h3 class="bot_preview_title mt-2">General settings</h3>
                <div class="bot_preview_box">
                  <!-- <div>
                    <span>Exchange</span><span class="border_line"></span
                    ><span>Binance</span>
                  </div> -->
                  <div>
                    <span>Total Open Pairs</span><span class="border_line"></span><span>{{ botDetails.totalBots
                      }}</span>
                  </div>
                  <div>
                    <span>Strategy</span><span class="border_line"></span><span>BOT</span>
                  </div>
                  <div>
                    <span>Investment</span><span class="border_line"></span><span>{{
                      truncateDecimals(botDetails?.totalInvestment?? botDetails.investment,4) }} USDT</span>
                  </div>
                </div>
              </div>
              <!-- <div>
                <h3 class="bot_preview_title mt-2">Bot settings</h3>
                <div class="bot_preview_box">
                  <div>
                    <span>Buy Investment %</span><span
                      class="border_line"></span><span>{{botDetails?.buyPercentage}}</span>
                  </div>
                  <div>
                    <span>Buy Count</span><span class="border_line"></span><span>{{botDetails?.buyCount}}</span>
                  </div>
                  <div>
                    <span>Sell Investment %</span><span
                      class="border_line"></span><span>{{botDetails?.sellPercentage}}</span>
                  </div>
                  <div>
                    <span>Sell Count</span><span class="border_line"></span><span>{{botDetails?.sellCount}}</span>
                  </div>
                  <div>
                    <span>Profit %</span><span class="border_line"></span><span>{{botDetails?.profitPercentage}}</span>
                  </div>
                  <div>
                    <span>Buy %</span><span class="border_line"></span><span>{{botDetails?.buyProfitPercentage}}</span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content" id="myTabContent" *ngIf="!botDetails.isBot">
      <div class="bot_preview_box_wrapper">
        <div>
          <div class="bot_preview_box">
            <div>
              <span>CreatedAt</span><span class="border_line"></span><span>{{
                dateTimeFormat(botDetails.createdAt)}}</span>
            </div>

            <div>
              <span>Symbol</span><span class="border_line"></span><span>{{botDetails.symbol}}</span>
            </div>

            <div>
              <span>Open Price</span><span class="border_line"></span><span>{{
                toFixedDown(
                botDetails.buyOrderId.status === "completed"
                ? botDetails.buyOrderId.execPrice
                : botDetails.buyOrderId.price,
                botDetails.buyOrderId.secondFloatDigit
                )
                }}</span>
            </div>

            <div>
              <span>Amount</span><span class="border_line"></span><span> {{
                toFixedDown(
                botDetails.buyOrderId.status === "completed"
                ? botDetails.buyOrderId.fillQuantity
                : botDetails.buyOrderId.quantity,
                botDetails.buyOrderId.firstFloatDigit
                )
                }}</span>
            </div>
            <div>
              <span>Status</span><span class="border_line"></span><span>{{botDetails.sellOrderId.status}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bgcolor d-flex align-items-center gap-2 collapse_btn">
    <!-- Collapsible Content -->
    <div class="collapsible-content" [@contentAnimation]="isCollapsed ? 'hidden' : 'visible'" *ngIf="!isCollapsed">
      <div class="bot-order-head">
        <h4>Bot actions</h4>
        <button class="bot-clear" (click)="toggleCollapse()">
          <img src="assets/images/botclear.svg" alt="close" title="close" />
        </button>
      </div>
      <div class="bot_preview_box_wrapper">
        <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#modify_bot_modal">
            <div class="bot_preview_box">
              <div>
                <h5>Modify Bot</h5>
                <p>Modify the current bot settings.</p>
              </div>
            </div>
          </a> -->
        <div class="bot_preview_box">
          <div>
            <button (click)="botCancel()">
              <h5>Stop Bot</h5>
              <p>Stop the bot's operations completely.</p>
            </button>
          </div>
        </div>
      </div>
      <!-- "Hide Content" Button -->
      <button class="continue bottom-btn" (click)="toggleCollapse()">
        Cancel
      </button>
    </div>

    <!-- "Show Content" Button -->
    <button class="toggle-btn continue" *ngIf="((botDetails.status == 'running' || !botDetails.isBot))  && isCollapsed"
      (click)="toggleCollapse()">
      Bot Action
    </button>
  </div>
</div>

<app-adminBotForm *ngIf="showCancel" [botDetails]="botDetails" orderStep="four"></app-adminBotForm>
<app-adminBotForm *ngIf="showBack" [botDetails]="botDetails" orderStep="one"></app-adminBotForm>